const headerData = [
	{
		types: "selection",
		columnwidth: 50,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 120
	},
	{
		prop: "InvName",
		label: "产品",
	},
	{
		prop: "TerminalHPName",
		label: "医院",
	},
	{
		prop: "BuyerName",
		label: "付款方",
	},
	{
		prop: "SBDate",
		label: "开票日期",
		columnwidth: 120
	},
	{
		prop: "InvoiceNo",
		label: "发生发票号",
		columnwidth: 150
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 120
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 160
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 120
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 160
	}
];
export default headerData;